import ColorPicker from "components/ColorPicker"
import {
  SingleSelectField,
  RadioField,
  TextField,
  InputError,
} from "components/RenderInput"
import { useEffect } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray } from "redux-form"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"

export const renderAnswersForm = ({
  fields,
  meta: { error, submitFailed },
  questionType,
  hasReplies,
  handleFieldFocus,
}) => {
  useEffect(() => {
    if (questionType === "1" && fields.length > 2) {
      fields.splice(1, fields.length - 2)
    }
  }, [questionType])

  return (
    <>
      {submitFailed && error && <span className={"input-error"}>{error}</span>}
      {fields.map((answer, index) => (
        <Row key={index} className="my-2 ms-1">
          <Col className="my-1">
            <Field
              name={`${answer}.answer`}
              component={TextField}
              placeholder={`Answer ${index + 1} Text  ${
                questionType === "1" ? "(5 characters max)" : ""
              }`}
              style={{ display: "inline" }}
              onFocus={handleFieldFocus}
            />
          </Col>
          <Col xs={4} className="mt-1">
            <Field
              name={`${answer}.value`}
              component={SingleSelectField}
              placeholder="Score"
              options={Array.from(Array(11).keys()).map(x => ({
                value: x,
                label: x,
              }))}
              onFocus={handleFieldFocus}
            />
          </Col>
          <Col xs={1} className="d-flex justify-content-end mt-2">
            {fields.length > 2 && (
              <i
                className="bx bx-sm bx-x"
                style={{
                  paddingLeft: "5px",
                  cursor: "pointer",
                }}
                onClick={
                  hasReplies
                    ? () => {}
                    : () => {
                        fields.remove(index)
                      }
                }
              />
            )}
          </Col>
        </Row>
      ))}
      {questionType !== "1" && (
        <Row>
          <Col>
            <p
              style={{ cursor: "pointer" }}
              onClick={
                hasReplies
                  ? () => {}
                  : () => fields.push({ answer: "", value: 0 })
              }
            >
              + Another Answer
            </p>
          </Col>
        </Row>
      )}
    </>
  )
}

export const renderQuestionsForm = ({
  fields,
  handleFieldFocus,
  hasReplies,
}) => {
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      fields.swap(fromIndex, toIndex)
    },
    nodeSelector: "div.card",
    handleSelector: "div.card",
    lineClassName: "dragDropLine",
  }
  return (
    <ReactDragListView {...dragProps}>
      {fields.map((question, index) => {
        const formValues = fields.get(index)
        return (
          <Card style={{ border: "1px solid black" }} key={index}>
            <CardHeader className="h5 bg-transparent border-bottom ">
              <Row>
                {fields.length > 1 && (
                  <Col xs={1}>
                    <i
                      className="bx bx-sm bx-menu"
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                )}
                <Col xs={10} style={{ display: "inline" }}>
                  <p
                    style={{ display: "inline", verticalAlign: "text-bottom" }}
                  >
                    Questionnaire Question #{index + 1}:
                  </p>
                </Col>
                {fields.length > 1 && (
                  <Col xs={1} style={{ display: "inline" }}>
                    <i
                      className="bx bx-sm bx-x"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={
                        hasReplies
                          ? () => {}
                          : () => {
                              fields.remove(index)
                            }
                      }
                    />
                  </Col>
                )}
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <Field
                    name={`${question}.question`}
                    component={TextField}
                    onFocus={handleFieldFocus}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <h5>Question Type:</h5>
                </Col>
              </Row>
              <Row>
                <Col className="my-1">
                  <Field
                    name={`${question}.questionType`}
                    component={RadioField}
                    value="1"
                    label="paired answers (2 answers) ie: true/false, yes/no"
                    type="radio"
                    onChange={
                      hasReplies
                        ? handleFieldFocus
                        : () => {
                            fields.splice(index, 1, {
                              ...formValues,
                              questionType: "1",
                            })
                          }
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col className="my-1">
                  <Field
                    name={`${question}.questionType`}
                    component={RadioField}
                    value="2"
                    label="multiple choice (one answer allowed)"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="my-1">
                  <Field
                    name={`${question}.questionType`}
                    component={RadioField}
                    value="3"
                    label="multiple choice (multiple answers allowed)"
                    type="radio"
                    onChange={handleFieldFocus}
                  />
                </Col>
              </Row>
              <FieldArray
                name={`${question}.answers`}
                component={renderAnswersForm}
                questionType={formValues.questionType}
                handleFieldFocus={handleFieldFocus}
                hasReplies={hasReplies}
              />
            </CardBody>
          </Card>
        )
      })}
    </ReactDragListView>
  )
}

const customTextField = ({
  input,
  type = "text",
  meta: { touched, error, submitFailed },
  color = "#FFFFFF",
}) => {
  return (
    <div>
      <input
        type={type}
        className="form-control"
        {...input}
        style={{
          background: "transparent",
          borderWidth: "0px 0px 1px",
          borderColor: "gray",
          outline: "none",
          color: `${color}`,
        }}
      />
      {(touched || submitFailed) && error && (
        <span className={"input-error"}>{error}</span>
      )}
    </div>
  )
}

export const renderResultsForm = ({ fields, handleFieldFocus, hasReplies }) =>
  fields.map((result, index) => {
    const formValues = fields.get(index)
    return (
      <Card style={{ border: "1px solid black" }} key={index}>
        <CardBody>
          <Row>
            <Col className="align-self-end" style={{ textAlign: "end" }}>
              {fields.length > 1 && (
                <i
                  className="bx bx-sm bx-x"
                  style={{
                    paddingLeft: "5px",
                    cursor: "pointer",
                  }}
                  onClick={
                    hasReplies
                      ? () => {}
                      : () => {
                          fields.remove(index)
                        }
                  }
                />
              )}
            </Col>
          </Row>
          <Row className="my-3 align-items-center">
            <Col xs="auto">
              <span>If total score is between</span>
            </Col>
            <Col xs={2} className="p-0">
              <Field
                name={`${result}.minScore`}
                component={TextField}
                type="number"
                min="0"
                onFocus={handleFieldFocus}
                onChange={handleFieldFocus}
              />
            </Col>
            <Col xs="auto">
              <span>and</span>
            </Col>
            <Col xs={2} className="p-0">
              <Field
                name={`${result}.maxScore`}
                component={TextField}
                type="number"
                min="0"
                onFocus={handleFieldFocus}
                onChange={handleFieldFocus}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={`${result}.topGradientColor`}
                component={ColorPicker}
                label="Result Top Gradient"
                disabled={hasReplies}
                onClick={handleFieldFocus}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={`${result}.bottomGradientColor`}
                component={ColorPicker}
                label="Result Bottom Gradient"
                disabled={hasReplies}
                onClick={handleFieldFocus}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={`${result}.textColor`}
                component={ColorPicker}
                label="Result Text Color"
                disabled={hasReplies}
                onClick={handleFieldFocus}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto">
              <Row style={{ marginBottom: "50px", marginTop: "15px" }}>
                Result Title:
              </Row>
              <Row style={{ marginBottom: "15px" }}>Result Description:</Row>
            </Col>
            <Col style={{ textAlign: "-webkit-center" }}>
              <Card
                style={{
                  background: `linear-gradient(${formValues.topGradientColor}, ${formValues.bottomGradientColor})`,
                  maxWidth: "80%",
                  borderRadius: "15px",
                }}
              >
                <Row
                  className="align-self-center"
                  style={{ marginBottom: "50px", marginTop: "15px" }}
                >
                  <Field
                    name={`${result}.title`}
                    type="text"
                    component={customTextField}
                    color={formValues.textColor}
                    onFocus={handleFieldFocus}
                  />
                </Row>
                <Row
                  className="align-self-center"
                  style={{ marginBottom: "15px" }}
                >
                  <Field
                    name={`${result}.description`}
                    type="text"
                    component="textarea"
                    style={{
                      background: "transparent",
                      borderWidth: "0px 0px 1px",
                      outline: "none",
                      width: "100%",
                      color: `${formValues.textColor}`,
                    }}
                    onFocus={handleFieldFocus}
                  />
                </Row>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
    )
  })

export const minPointsCalculator = values => {
  let min = 0
  values.questions.forEach(question => {
    let currentQuestionMin = 10
    question.answers.forEach(answer => {
      if (parseInt(answer.value) < currentQuestionMin) {
        currentQuestionMin = parseInt(answer.value)
      }
    })
    min += currentQuestionMin
  })
  return min
}

export const maxPointsCalculator = values => {
  let max = 0
  values.questions.forEach(question => {
    if (question.questionType === "3") {
      max += question.answers
        .map(answer => parseInt(answer.value))
        .reduce((prev, current) => prev + current)
    } else {
      let currentQuestionMax = 0
      question.answers.forEach(answer => {
        if (parseInt(answer.value) > currentQuestionMax) {
          currentQuestionMax = parseInt(answer.value)
        }
      })
      max += currentQuestionMax
    }
  })
  return max
}
